import { API } from "../api/API";

const getAssures = () => {
  return API.get("/assures");
};
const createAssure = async (assure) => {
  try {
    const res = await API.post("/assures", assure);
    return res.data;
  } catch (error) {
    console.log(error.message);
  }
};

const updateAssure = async (assure) => {
  try {
    const res = await API.put(`/assures/${assure.id}`, assure);
    return res.data;
  } catch (error) {
    console.log(error.message);
  }
};

const deleteAssure = async (id) => {
  try {
    const res = await API.delete(`/assures/${id}`);
    return res.data;
  } catch (error) {
    console.log(error.message);
  }
};

const getPolices = async () => {
  try {
    const res = await API.get("/polices");
    return res.data;
  } catch (error) {
    console.log(error.message);
  }
};
const createPolice = async (police) => {
  try {
    const res = await API.post("/polices", police);
    return res.data;
  } catch (error) {
    console.log(error.message);
  }
};

const updatePolice = async (police) => {
  try {
    const res = await API.put(`/polices/${police.id}`, police);
    return res.data;
  } catch (error) {
    console.log(error.message);
  }
};

const deletePolice = async (id) => {
  try {
    const res = await API.delete(`/polices/${id}`);
    return res.data;
  } catch (error) {
    console.log(error.message);
  }
};

export const AssureService = {
  getAssures,
  createAssure,
  updateAssure,
  deleteAssure,
  getPolices,
  createPolice,
  updatePolice,
  deletePolice,
};
